import { setTimeout, runOnReadyState, clearTimeout, mockable } from '@datadog/browser-core';
import { getNavigationEntry, sanitizeFirstByte } from '../../../browser/performanceUtils';
export function trackNavigationTimings(configuration, callback) {
    return waitAfterLoadEvent(configuration, () => {
        const entry = mockable(getNavigationEntry)();
        if (!isIncompleteNavigation(entry)) {
            callback(processNavigationEntry(entry));
        }
    });
}
function processNavigationEntry(entry) {
    return {
        domComplete: entry.domComplete,
        domContentLoaded: entry.domContentLoadedEventEnd,
        domInteractive: entry.domInteractive,
        loadEvent: entry.loadEventEnd,
        firstByte: sanitizeFirstByte(entry),
    };
}
function isIncompleteNavigation(entry) {
    return entry.loadEventEnd <= 0;
}
function waitAfterLoadEvent(configuration, callback) {
    let timeoutId;
    const { stop: stopOnReadyState } = runOnReadyState(configuration, 'complete', () => {
        // Invoke the callback a bit after the actual load event, so the "loadEventEnd" timing is accurate
        timeoutId = setTimeout(() => callback());
    });
    return {
        stop: () => {
            stopOnReadyState();
            clearTimeout(timeoutId);
        },
    };
}
//# sourceMappingURL=trackNavigationTimings.js.map